import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/leadActivitySagas";

export function UpdateBtns() {
  const dispatch = useDispatch();

  const filtersDirty = useSelector((state) => state.leadActivity.filtersDirty);

  return filtersDirty ? (
    <div className="buttons-wrapper">
      <button
        className="submit"
        onClick={() => {
          dispatch(actionCreators.updateTable());
        }}
      >
        Update
      </button>

      <button
        className="submit reset"
        onClick={() => {
          dispatch(actionCreators.resetFilters());
        }}
      >
        Reset
      </button>
    </div>
  ) : null;
}
